import { ReactNode } from "react";
import { Col } from "react-bootstrap";

const ColM = ({
  children,
  xs,
  md,
  lg,
  xl,
  className,
  max,
}: {
  children: ReactNode;
  xs?: number;
  md?: number;
  lg?: number;
  xl?: number;
  className?: string;
  max?: boolean;
}) => {
  return (
    <Col
      xs={xs}
      md={md}
      lg={lg}
      xl={xl}
      style={{
        borderLeft: "8px solid transparent",
        borderRight: "8px solid transparent",
        borderBottom: "16px solid transparent",
        padding: 0,
      }}
      className={`${className} col-bottom`}
    >
      <div className={`bg-white shadow rounded py-4 px-3 ${!max && "h-100"}`}>
        {children}
      </div>
    </Col>
  );
};

export default ColM;
